import React, { useEffect, useState } from "react";
import SideBar from "../common/SideBar";
import AuthGuard from "../../guards/AuthGuard";
import NavBar from "../common/NavBar";
import { Outlet, useNavigate } from "react-router-dom";
import { MenuItems, menuItems } from "../../data/MenuItems";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import { adminMenuItems } from "../../data/AdminMenuItems";
import KycGuard from "../../guards/KycGuard";
import {AuthService} from "../../services/authService";

type DashboardLayoutProps = {};

const DashboardLayout: React.FC<DashboardLayoutProps> = () => {
  const [isSidebarExpanded, setSidebarExpanded] = useState(true);
  const [sideBarItems, setSideBarItems] = useState<MenuItems[]>([]);
  const navigate = useNavigate();
  const { currentUser, loading } = useSelector(
    (state: RootState) => state.auth
  );

  const silentLogout = async () => {
      navigate("/auth", { replace: true });
  };

  useEffect(() => {
    if (!loading) {

      const menuElements =
        currentUser?.role.role_code === "CUSTOMER" ||
        currentUser?.role.role_code === "ENTERPRISE"
          ? menuItems
          : adminMenuItems;

      setSideBarItems(menuElements);
    }
  }, [currentUser?.role?.role_code, currentUser, loading]);

  return (
    <AuthGuard>
      <KycGuard>
        <div className="flex">
          <SideBar
            menuItems={sideBarItems}
            isExpanded={isSidebarExpanded}
            setIsExpanded={setSidebarExpanded}
          />
          <main
            className={`dashboard-main w-full flex-1 transition-all duration-300 ${isSidebarExpanded ? "md:ml-64" : "md:ml-24"}`}
          >
            <NavBar
              isExpanded={isSidebarExpanded}
              setIsExpanded={setSidebarExpanded}
            />

            <div className="dashboard-main-body p-6">
              <Outlet />
            </div>
          </main>
        </div>
      </KycGuard>
    </AuthGuard>
  );
};

export default DashboardLayout;
